import { create } from 'zustand';
import type { Project } from '@pulsewright/shared';
import { createEmptyProject } from '../lib/project-factory';

interface ProjectState {
  project: Project;
  /** Mutation actions live here once the editor is implemented (Phase 1 step 5+). */
  setProject: (p: Project) => void;
  reset: () => void;
}

export const useProjectStore = create<ProjectState>((set) => ({
  project: createEmptyProject(),
  setProject: (project) => set({ project }),
  reset: () => set({ project: createEmptyProject() }),
}));
